import React from "react";
import { Link } from "react-router-dom";

export const religionColumns = (handleEdit, handleDelete, handleHomePageToggle, PAGE_SIZE) => [
  {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Religion",
    key: "name",
    sortable: false,
  },
  {
    label: "Status",
    key: "status",
    width: 120,
    sortable: false,
    render: (row) => (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Home Page",
    key: "homePage",
    width: 120,
    sortable: false,
    render: (row) => (
      <input
        type="checkbox"
        checked={!!row.homePage}
        onChange={() => handleHomePageToggle(row)}
        title="Show on Home Page"
      />
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link to="#" onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
